import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import { AUTH_TYPES, FORMS, MODULES, STATUS_GROUPS } from "../../../const";
import Input from "../../input/Input";
import Dropdown from "../../input/Dropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import {
  shiftActionsValidation,
  shiftUserValidation,
} from "../../validations/ShiftCreation";
import { getUsernameById } from "../../../api/systemUserApi";
import Button from "../../input/Button";
import Grid from "../../Grid";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import { isNumber } from "../../../helper";
import {
  statusByContext,
  StatusById,
  statusManagerById,
} from "../../../api/statusApi";
import {
  getShiftActionById,
  getShiftUserById,
  shiftUserFindByActionId,
} from "../../../api/shiftApi";
import { toast } from "react-toastify";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import useUserCompany from "../../../hooks/useUserCompany";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const FORM = FORMS.CALL_CENTER_SHIFT.SHIFT_ACTION.form;
const ShiftActionForm = forwardRef(
  ({ isLoading, currentValues, editMode }, ref) => {
    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    const [shiftActionData, setShiftActionData] = useState({
      shaCode: "",
      shaReferance: "",
      shaCompany: company,
      shaMasterStatus: null,
      shaStatusCode: "",
      shaDescription: "",
      shaStatus: 2,
      shaActive: 1,
    });

    // errors

    const [currentErrors, setCurrentErrors] = useState({});

    const [currentShiftActions, setCurrentShiftActions] = useState({});
    const [shiftActions, setShiftActions] = useState([]);
    const [shiftActionsCount, setShiftActionsCount] = useState(2);
    const [deletedList, setDeletedList] = useState([]);
    const [mFields, setMFields] = useState({});
    const [auditInfo, setAuditInfo] = useState({});

    // bool
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [actionStatusOptions, setActionStatusOptions] = useState([]);

    useEffect(() => {
      (async () => {
        //new

        const { active, status } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);

        const actionStatusData = await statusByContext(STATUS_GROUPS.ALL);
        setActionStatusOptions(actionStatusData);
      })();
    }, []);

    const onAddClick = async () => {
      setIsAddLoading(true);

      let shiftActionErrors = shiftActionsValidation({
        ...shiftActionData,
      });

      if (Object.keys(shiftActionErrors).length === 0) {
        const response = await shiftUserFindByActionId(
          shiftActionData.shaMasterStatus,
        );

        if (
          Object.keys(currentShiftActions).length === 0 &&
          shiftActions.some(
            (action) =>
              action?.shaMasterStatus === shiftActionData.shaMasterStatus,
          )
        ) {
          toast.error(
            "There was an error adding shift action already added to grid!",
            { autoClose: 5000, containerId: "Main" },
          );
        } else if (!shiftActionData.id && response !== "") {
          toast.error(
            "There was an error adding shift action already exists!",
            { autoClose: 5000, containerId: "Main" },
          );
        } else {
          const statusValue = await getTextByValueAndKey(
            "status",
            shiftActionData.shaStatus,
          );
          const activeValue = await getTextByValueAndKey(
            "active",
            shiftActionData.shaActive,
          );
          const masterStatusValue = await StatusById(
            shiftActionData.shaMasterStatus,
          );
          if (!shiftActionData.shaId || shiftActionData.shaId === null) {
            if (!shiftActionData.id || shiftActionData.id === null) {
              setShiftActions((prevState) => [
                ...prevState,
                {
                  ...shiftActionData,
                  id: shiftActionsCount,
                  status: statusValue,
                  active: activeValue,
                  mstatus: masterStatusValue.staName,
                },
              ]);
              setShiftActionsCount((prevState) => ++prevState);
            } else {
              setShiftActions((prevState) =>
                prevState.filter((item) => item.id !== shiftActionData.id),
              );
              setShiftActions((prevState) => [
                ...prevState,
                {
                  ...shiftActionData,
                  status: statusValue,
                  active: activeValue,
                  mstatus: masterStatusValue.staName,
                },
              ]);
            }
          } else {
            setShiftActions((prevState) =>
              prevState.filter((item) => item.shaId !== shiftActionData.shaId),
            );
            setShiftActions((prevState) => [
              ...prevState,
              {
                ...shiftActionData,
                modifed: true,
                status: statusValue,
                active: activeValue,
                mstatus: masterStatusValue.staName,
              },
            ]);
          }
          setButtonClicked(true);
        }
      }
      setCurrentErrors(shiftActionErrors);
      setIsAddLoading(false);
    };
    useEffect(() => {
      if (buttonClicked) {
        setShiftActionData({
          shaCode: "",
          shaReferance: "",
          shaCompany: company,
          shaMasterStatus: null,
          shaStatusCode: "",
          shaDescription: "",
          shaStatus: 2,
          shaActive: 1,
        });
        setButtonClicked(false);
        setSearchFieldReset(true);
        setCurrentShiftActions({});
      }
    }, [buttonClicked]);

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            created: [],
            deleted: deletedList,
          };

          shiftActions.forEach((sha) => {
            if (sha.shaId && sha.shaId !== null) {
              if (sha.modifed) {
                updateState.modified.push(sha);
              }
            } else {
              updateState.created.push(sha);
            }
          });

          return updateState;
        } else {
          return shiftActions;
        }
      },
      resetForm: () => {
        setButtonClicked(true);
        setShiftActions([]);
      },
    }));

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentActions = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const statusValue = await getTextByValueAndKey(
              "status",
              currentValue.shaStatus,
            );
            const activeValue = await getTextByValueAndKey(
              "active",
              currentValue.shaActive,
            );
            const masterStatusValue = await StatusById(
              currentValue.shaMasterStatus,
            );
            currentActions.push({
              ...currentValue,
              status: statusValue,
              active: activeValue,
              mstatus: masterStatusValue.staName,
              shaCompany: company,
              id,
            });
            ++id;
          }
          setShiftActionsCount(id);
          setShiftActions(currentActions);
          setAuditInfo({
            createdDate: currentValues[0].createdDate,
            createdBy: currentValues[0].createdBy,
            lastModifiedBy: currentValues[0].lastModifiedBy,
            lastModifiedDate: currentValues[0].lastModifiedDate,
          });
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      if (Object.keys(currentShiftActions).length > 0) {
        setShiftActionData({
          ...currentShiftActions,
        });
      }
    }, [editMode, currentShiftActions]);

    const addStatusCode = async (value) => {
      const response = await StatusById(value);
      setShiftActionData((prevState) => ({
        ...prevState,
        shaStatusCode: response ? response.staRefCode : "",
      }));
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Actions</h4>
              <div className="two fields">
                <Dropdown
                  required={true}
                  disabled={editMode}
                  clearable
                  search={true}
                  options={actionStatusOptions}
                  placeholder="Master Status"
                  label="Master Status"
                  error={currentErrors.shaMasterStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="sha_status"
                  editMode={editMode}
                  value={shiftActionData.shaMasterStatus}
                  onChange={(e, data) => {
                    setShiftActionData((prevState) => ({
                      ...prevState,
                      shaMasterStatus: data.value,
                    }));
                    addStatusCode(data.value);
                  }}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaMasterStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  // multiple={true}
                />
                <Input
                  label="Status Code"
                  error={currentErrors.shaStatusCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="sha_sta_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaStatusCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shaStatusCode"
                  value={shiftActionData.shaStatusCode}
                  onChange={(e) => {
                    setShiftActionData((prevState) => ({
                      ...prevState,
                      shaStatusCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <Input
                  label="Description"
                  error={currentErrors.shaDescription}
                  module={MODULES.Master}
                  form={FORM}
                  field="shi_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftActionData.shaDescription}
                  onChange={(e) => {
                    setShiftActionData((prevState) => ({
                      ...prevState,
                      shaDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.shaStatus}
                  module={MODULES.Master}
                  form={FORM}
                  field="sha_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftActionData.shaStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftActionData((prevState) => ({
                      ...prevState,
                      shaStatus: data.value,
                    }));
                  }}
                />

                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.shaActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="sha_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { shaActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftActionData.shaActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftActionData((prevState) => ({
                      ...prevState,
                      shaActive: data.value,
                    }));
                  }}
                /> */}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
              <Button
                template="addOrSave"
                authenticated={true}
                editMode={editMode}
                module={MODULES.Master}
                form={`${FORM}`}
                create={Object.keys(currentShiftActions).length === 0}
                disabled={
                  editMode && Object.keys(currentShiftActions).length === 0
                }
                onClick={onAddClick}
                isLoading={isAddLoading}
              />
            </div>
            {/*<small style={{color: "#9f3a38"}}>{`${*/}
            {/*    currentErrors.mainCountError ? currentErrors.mainCountError : ""*/}
            {/*}`}</small>*/}
            <Grid
              heading="Action List"
              config={[
                { headerName: "Master Status", field: "mstatus" },
                {
                  headerName: "Description",
                  field: "shaDescription",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                {
                  headerName: "Status",
                  field: "status",
                  cellRenderer: StatusCellStyle,
                },
                {
                  headerName: "Active",
                  field: "active",
                  cellRenderer: ActiveCellStyle,
                },
                {
                  field: "Edit",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.CREATE,
                    clickHandler: () => {
                      setCurrentShiftActions(params.data);
                    },
                    label: "Edit",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Master,
                    editMode: editMode,
                  }),
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: DeleteButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.DELETE,
                    clickHandler: () => {
                      if (params.data.shaId && params.data.shaId !== null) {
                        setDeletedList((prevState) => [
                          ...prevState,
                          params.data.shaId,
                        ]);
                      }
                      setShiftActions((prevShift) =>
                        prevShift.filter(
                          (action) => action.id !== params.data.id,
                        ),
                      );
                    },
                    message: "Are you sure you want to delete this Action?",
                    label: "Delete",
                    className: "ui red button",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Master,
                    editMode:
                      params.data.shaId !== null && isNumber(params.data.shaId),
                  }),
                },
              ]}
              content={shiftActions}
            />
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: auditInfo.createdBy ? auditInfo.createdBy : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: auditInfo.createdDate
                      ? formatFromJsonDate(auditInfo.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: auditInfo.lastModifiedBy
                      ? auditInfo.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: auditInfo.lastModifiedDate
                      ? formatFromJsonDate(auditInfo.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  },
);

export default ShiftActionForm;
